import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import moment from "moment-timezone";
import Header from "../layout/Header";
import Footer from "../layout/Footer";
import Loader from "../layout/Loader";
import Pagination from "../layout/Pagination";
import PermissionGate from "../layout/PermissionGate";

const STATUS_TABS = [
    { value: "pending", label: "Pending" },
    { value: "rejected", label: "Rejected" },
    { value: "all", label: "All" },
];

const MerchantSignups = () => {
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [page, setPage] = useState(1);
    const [count, setCount] = useState(0);
    const [search, setSearch] = useState("");
    const [status, setStatus] = useState("pending");
    const token = localStorage.getItem("token");
    const limit = process.env.REACT_APP_PAGINATION_LIMIT;

    const fetchSignups = () => {
        axios
            .get(
                `${process.env.REACT_APP_API_ENDPOINT}all-merchant-signups?page=${page}&limit=${limit}&search=${search}&status=${status}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                },
            )
            .then((res) => {
                if (res.data.code === 1) {
                    if (page > 1 && res.data.data.length === 0) {
                        setPage(page - 1);
                    } else {
                        setData(res.data.data);
                        setCount(res.data.count);
                        setIsLoading(false);
                    }
                } else {
                    setIsLoading(false);
                }
            })
            .catch(console.error);
    };

    useEffect(() => {
        fetchSignups();
    }, [page, search, status]);

    const statusBadgeClass = (value) => {
        if (value === "approved") {
            return "badge text-white bg-success";
        }
        if (value === "rejected") {
            return "badge text-white bg-danger";
        }
        return "badge text-white bg-warning";
    };

    return isLoading === true ? (
        <Loader />
    ) : (
        <div className="d-flex flex-column flex-root">
            <div className="page d-flex flex-row flex-column-fluid">
                <div
                    className="wrapper d-flex flex-column flex-row-fluid"
                    id="kt_wrapper"
                >
                    <Header />
                    <div className="app-body">
                        <div className="toolbar py-3 py-lg-6" id="kt_toolbar">
                            <div
                                id="kt_toolbar_container"
                                className=" container-xxl  d-flex flex-stack flex-wrap gap-2"
                            >
                                <div className="page-title d-flex flex-column align-items-start me-3 py-2 py-lg-0 gap-2">
                                    <h1 className="d-flex text-dark fw-bold m-0 fs-3">
                                        Merchant Signups
                                    </h1>
                                </div>
                                <div className="d-flex align-items-center overflow-auto">
                                    {STATUS_TABS.map((tab) => (
                                        <button
                                            key={tab.value}
                                            onClick={() => {
                                                setPage(1);
                                                setStatus(tab.value);
                                            }}
                                            className={
                                                status === tab.value
                                                    ? "btn btn-color-light bg-primary me-3"
                                                    : "btn btn-color-primary bg-body me-3"
                                            }
                                        >
                                            {tab.label}
                                        </button>
                                    ))}
                                </div>
                            </div>
                        </div>

                        <div
                            id="kt_content_container"
                            className="d-flex flex-column-fluid align-items-start  container-xxl "
                        >
                            <div className="content flex-row-fluid" id="kt_content">
                                <PermissionGate required={`view_merchant_signups`}>
                                    <div className="card">
                                        <div className="card-header border-0 pt-6">
                                            <div className="my-1 w-100">
                                                <input
                                                    value={search}
                                                    onChange={(e) => {
                                                        setPage(1);
                                                        setSearch(e.target.value);
                                                    }}
                                                    type="text"
                                                    className="form-control w-100"
                                                    placeholder="Search by merchant name, legal name, email or source"
                                                />
                                            </div>
                                        </div>

                                        <div className="card-body py-4 text-center">
                                            {data?.length === 0 ? (
                                                <div className="text-center w-100">
                                                    <img
                                                        className="w-25 mx-auto py-20"
                                                        src={`${process.env.REACT_APP_PUBLIC_URL}assets/media/misc/no-content.png`}
                                                        alt="no-content"
                                                    />
                                                </div>
                                            ) : (
                                                <div className="table-responsive">
                                                    <table className="table align-middle table-row-dashed fs-6 gy-5">
                                                        <thead>
                                                            <tr className="text-muted fw-bold fs-7 text-uppercase gs-0">
                                                                <th className="text-center min-w-150px">
                                                                    Merchant Name
                                                                </th>
                                                                <th className="text-center min-w-100px">
                                                                    Type
                                                                </th>
                                                                <th className="text-center min-w-100px">
                                                                    Currency
                                                                </th>
                                                                <th className="text-center min-w-150px">
                                                                    Email
                                                                </th>
                                                                <th className="text-center min-w-100px">
                                                                    Source
                                                                </th>
                                                                <th className="text-center min-w-100px">
                                                                    Applied On
                                                                </th>
                                                                <th className="text-center min-w-100px">
                                                                    Status
                                                                </th>
                                                                <th className="text-center min-w-100px">
                                                                    Actions
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody className="text-gray-600 fw-semibold">
                                                            {data &&
                                                                data.map((signup, index) => (
                                                                    <tr className="text-center" key={index}>
                                                                        <td>
                                                                            <Link
                                                                                to={`/merchants/signup-details/${signup._id}`}
                                                                                className="text-gray-800 text-hover-primary"
                                                                            >
                                                                                {signup.merchantName}
                                                                            </Link>
                                                                            <div className="text-muted fs-7">
                                                                                {signup.legalName}
                                                                            </div>
                                                                        </td>
                                                                        <td>{signup.merchantType}</td>
                                                                        <td>
                                                                            <div className="badge bg-warning text-white badge-light fw-bold">
                                                                                {signup.currency}
                                                                            </div>
                                                                        </td>
                                                                        <td>{signup.email}</td>
                                                                        <td>
                                                                            {signup.referralSource ? (
                                                                                <span className="badge bg-light-info text-info fw-bold">
                                                                                    {signup.referralSource}
                                                                                </span>
                                                                            ) : (
                                                                                <span className="text-muted">—</span>
                                                                            )}
                                                                        </td>
                                                                        <td>
                                                                            {moment(signup.createdAt)
                                                                                .tz(process.env.REACT_APP_TIMEZONE)
                                                                                .format("Do MMM, YYYY")}
                                                                        </td>
                                                                        <td>
                                                                            <span
                                                                                className={statusBadgeClass(
                                                                                    signup.status,
                                                                                )}
                                                                            >
                                                                                {signup.status}
                                                                            </span>
                                                                        </td>
                                                                        <td>
                                                                            <Link
                                                                                to={`/merchants/signup-details/${signup._id}`}
                                                                                className="btn px-2 btn-outline btn-success btn-color-white btn-sm"
                                                                                data-bs-toggle="tooltip"
                                                                                data-bs-placement="top"
                                                                                title="Review Application"
                                                                            >
                                                                                <i className="bi-duotone bi-eye fs-5"></i>
                                                                            </Link>
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            )}

                                            {count && Math.ceil(count / limit) > 1 ? (
                                                <Pagination
                                                    page={page}
                                                    setPage={setPage}
                                                    count={count}
                                                    limit={limit}
                                                />
                                            ) : (
                                                ""
                                            )}
                                        </div>
                                    </div>
                                </PermissionGate>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            </div>
        </div>
    );
};

export default MerchantSignups;